export function sortBy(sortKey: string, sortOrder: number, key: string) {
  if (sortKey === key) {
    if (sortOrder === 1) {
      sortOrder = -1; // second click, descending
    } else if (sortOrder === -1) {
      sortKey = ""; // third click, reset sort
      sortOrder = 1; // default sort order for the next click
    }
  } else {
    sortKey = key;
    sortOrder = 1; // first click, ascending
  }

  return {
    sortKey,
    sortOrder,
  };
}

export function isActiveSort(sortKey: string, key: string): string {
  return sortKey === key ? "active-sort" : "";
}

export function getSortArrowIcon(
  sortKey: string,
  sortOrder: number,
  key: string
): string {
  if (sortKey === key) {
    return sortOrder === 1 ? "" : sortOrder === -1 ? "" : " ";
  }

  return "icon-filter-default";
}

export function getSortArrow(
  sortKey: string,
  sortOrder: number,
  key: string
): string {
  if (sortKey === key) {
    return sortOrder === 1 ? "▲" : sortOrder === -1 ? "▼" : " ";
  }

  return "";
}

export function sort(array: any[], sortKey: string, sortOrder: number) {
  return array.sort((a, b) => {
    let valA = a ? a[sortKey] : null;
    let valB = b ? b[sortKey] : null;

    if (typeof valA === "string") {
      valA = valA.toLowerCase();
    }

    if (typeof valB === "string") {
      valB = valB.toLowerCase();
    }

    if (valA < valB) {
      return -1 * sortOrder;
    } else if (valA > valB) {
      return 1 * sortOrder;
    }

    return 0;
  });
}
